import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';

import { useAppSelector } from 'src/app/store/hooks';
import type { RootState } from 'src/app/store/types';
import {
  DriversListApiArg,
  useDriversListQuery,
} from 'src/common/external/bambi-api/bambiApi';

import { convertDriversToDriverProfiles } from './convertDriversToDriverProfiles';

export function useCurrentOrganizationDriverProfiles() {
  const includeDeleted = useAppSelector(
    (state) => state.team.showDeletedDrivers
  );

  const driverProfileSearchTerm = useSelector(
    (state: RootState) => state.team.driverProfileSearchTerm
  );

  const driverTags = useAppSelector((state) => state.team.driverTags);

  const { data, isLoading, isFetching, refetch } = useDriversListQuery({
    search: driverProfileSearchTerm,
    tags: driverTags.length > 0 ? driverTags : undefined,
    ordering: (useSearchParams()[0].get('ordering') ||
      '') as DriversListApiArg['ordering'],
    deletedObjects: includeDeleted ? 'include' : undefined,
  });

  return {
    drivers: convertDriversToDriverProfiles(data?.results),
    isLoading,
    isFetching,
    refetch,
  };
}
